import * as path from 'node:path';
import os from 'node:os';

export function defaultWorktreesRootPath(): string {
  return path.join(os.homedir(), '.buildautomaton', 'worktrees');
}
